import React, { useState, useEffect } from 'react';
import { Button, Spinner, Text, Link } from '@fluentui/react-components';
import { EmailData, RelatedItem } from '@shared/types/email';
import { apiService } from '../services/apiService';

interface LinksPanelProps {
  email: EmailData;
}

const LinksPanel: React.FC<LinksPanelProps> = ({ email }) => {
  const [relatedItems, setRelatedItems] = useState<RelatedItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadLinks = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await apiService.getRelatedLinks(email.id);
      setRelatedItems(data.relatedItems || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load related links');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (email.id) {
      loadLinks();
    }
  }, [email.id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spinner label="Finding related items..." />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Text>{error}</Text>
        <Button onClick={loadLinks} style={{ marginTop: '10px' }}>
          Retry
        </Button>
      </div>
    );
  }

  if (relatedItems.length === 0) {
    return (
      <div>
        <Text>No related items found.</Text>
        <Button onClick={loadLinks} style={{ marginTop: '10px' }}>
          Search Again
        </Button>
      </div>
    );
  }

  return (
    <div>
      <Text weight="semibold" size={400} style={{ display: 'block', marginBottom: '12px' }}>
        Related Items ({relatedItems.length})
      </Text>
      {relatedItems.map((item, index) => (
        <div key={index} style={{ marginBottom: '16px', padding: '12px', border: '1px solid #e1dfdd', borderRadius: '4px' }}>
          <Text weight="semibold" size={300} style={{ display: 'block', marginBottom: '4px' }}>
            {item.type === 'email' ? '📧 Email' : '📄 Document'}
          </Text>
          <Link href={item.url} target="_blank" style={{ display: 'block', marginBottom: '8px' }}>
            {item.title}
          </Link>
          {item.summary && (
            <Text size={200} style={{ display: 'block', marginBottom: '4px', color: '#666' }}>
              {item.summary}
            </Text>
          )}
          <Text size={200} style={{ color: '#666' }}>
            {new Date(item.date).toLocaleDateString()} • Relevance: {Math.round(item.relevanceScore * 100)}%
          </Text>
        </div>
      ))}
    </div>
  );
};

export default LinksPanel;





